<!-- TODO: add all loaders from here (https://loading.io/css/), and select to dr settings -->
<template>
	<div class="w-full">
		<div class="lds-ring w-full mx-auto max-w-xs"><div></div><div></div><div></div><div></div></div>
		<slot></slot>
	</div>
</template>

<script>

export default {
    name: "Loader",
}
</script>

<style scoped>
.lds-ring {
	display: block;
	position: relative;
	width: 80px;
	height: 80px;
}
.lds-ring div {
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: 64px;
	height: 64px;
	margin: 8px;
	border: 8px solid #424242;
	border-radius: 50%;
	animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: #424242 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
	animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
	animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
	animation-delay: -0.15s;
}
@keyframes lds-ring {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>